var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2414)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_2414)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 6H14C11.7909 6 10 7.79086 10 10V28C10 30.2091 11.7909 32 14 32H32C34.2091 32 36 30.2091 36 28V10C36 7.79086 34.2091 6 32 6Z",
    fill: "#A92C2C"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.0001 2H14.0001C11.791 2 10.0001 3.79086 10.0001 6V24C10.0001 26.2091 11.791 28 14.0001 28H32.0001C34.2092 28 36.0001 26.2091 36.0001 24V6C36.0001 3.79086 34.2092 2 32.0001 2Z",
    fill: "#F13838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4191 11.99H17.6941V10.82C18.1641 10.82 18.5391 10.78 18.8191 10.7C19.1091 10.62 19.3391 10.49 19.5091 10.31C19.6791 10.12 19.8291 9.85 19.9591 9.5H21.0691V20H19.4191V11.99ZM25.455 20.15C24.645 20.15 24.03 19.925 23.61 19.475C23.2 19.025 22.995 18.38 22.995 17.54V16.685H24.555V17.615C24.555 18.305 24.84 18.65 25.41 18.65C25.69 18.65 25.9 18.565 26.04 18.395C26.19 18.215 26.265 17.905 26.265 17.465V16.61C26.265 16.13 26.18 15.79 26.01 15.59C25.84 15.38 25.565 15.275 25.185 15.275H24.63V13.775H25.23C25.56 13.775 25.805 13.69 25.965 13.52C26.135 13.35 26.22 13.065 26.22 12.665V11.9C26.22 11.54 26.145 11.275 25.995 11.105C25.845 10.935 25.645 10.85 25.395 10.85C24.865 10.85 24.6 11.175 24.6 11.825V12.515H23.04V11.96C23.04 11.12 23.245 10.475 23.655 10.025C24.075 9.575 24.675 9.35 25.455 9.35C26.245 9.35 26.845 9.575 27.255 10.025C27.665 10.465 27.87 11.105 27.87 11.945V12.32C27.87 12.89 27.775 13.35 27.585 13.7C27.395 14.04 27.1 14.285 26.7 14.435V14.465C27.13 14.625 27.44 14.885 27.63 15.245C27.82 15.605 27.915 16.065 27.915 16.625V17.555C27.915 18.395 27.705 19.04 27.285 19.49C26.875 19.93 26.265 20.15 25.455 20.15Z",
    fill: "#111820"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_2414",
    x: 0,
    y: 0,
    width: 46,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_2414"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_2414",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2414"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg13);
export default __webpack_public_path__ + "static/media/13.0df186b22a0544f175afc7caf67b376b.svg";
export { ForwardRef as ReactComponent };